import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const LOADING_SAYINGS = [
  "Crunching the numbers...",
  "Finding the perfect comps...",
  "Analyzing market trends...",
  "Polishing the details...",
  "Almost there...",
  "Gathering neighborhood insights...",
  "Putting the finishing touches...",
  "Calculating property value...",
  "Reviewing listing performance...",
  "Compiling your report...",
  "Analyzing comparable properties...",
  "Reviewing market data...",
];

interface PublicReportLoadingProps {
  companyLogoUrl?: string | null;
}

export function PublicReportLoading({ companyLogoUrl }: PublicReportLoadingProps) {
  const [currentSayingIndex, setCurrentSayingIndex] = useState(0);

  useEffect(() => {
    // Rotate sayings every 2.5 seconds
    const interval = setInterval(() => {
      setCurrentSayingIndex((prev) => (prev + 1) % LOADING_SAYINGS.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardContent className="p-12 flex flex-col items-center justify-center space-y-6">
          {/* Company Logo with Pulse Animation */}
          {companyLogoUrl && (
            <div className="mb-4">
              <img
                src={companyLogoUrl}
                alt="Company Logo"
                className="h-16 w-auto max-w-[200px] object-contain animate-pulse"
              />
            </div>
          )}

          {/* Animated Spinner */}
          <div className="relative">
            <Loader2 className="h-12 w-12 text-primary animate-spin" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-8 w-8 rounded-full border-2 border-primary/20"></div>
            </div>
          </div>

          {/* Rotating Saying with Fade Transition */}
          <div className="h-8 flex items-center justify-center">
            <p
              key={currentSayingIndex}
              className="text-lg text-muted-foreground text-center animate-in fade-in duration-500"
            >
              {LOADING_SAYINGS[currentSayingIndex]}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

